import { httpHandler } from '../httpHandler'

export const create = body => httpHandler.post({url: `/w/seller/signup/personal`, options: { body } });

